import wx from 'weixin-js-sdk'
import { getEnv, getQueryString } from '@/assets/js/common.js'
import { loginBySign } from '@/api/activity'

const appLogin = {
  isAndroid: function () {
    let u = navigator.userAgent
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
    return isAndroid
  },
  isIos: function () {
    let u = navigator.userAgent
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    return isiOS
  },
  callAppLogin: function (callbackObj) {
    let fn = callbackObj.callback
    callbackObj.callback = fn.toString()
    if (this.isAndroid()) {
      console.log('app中callLogin2方法打印', window.jsObj.callLogin2)
      if (window.jsObj && window.jsObj.callLogin2) {
        console.log('新版本app走callLogin2登录', window.jsObj.callLogin2)
        window.jsObj.callLogin2(JSON.stringify(callbackObj))
      } else {
        console.log('app老版本走m站登录', mLogin.callMLogin)
        mLogin.callMLogin()
      }
    } else {
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.callLogin2) {
        window.webkit.messageHandlers.callLogin2.postMessage(callbackObj)
      } else {
        mLogin.callMLogin()
      }
    }
  },
  callApp24Login: function (callbackObj) {
    let fn = callbackObj.callback
    callbackObj.callback = fn.toString()
    if (window.env == 'sit' || window.env == 'dev') {
      callbackObj.keyCode = 124
    } else if (window.env == 'uat') {
      callbackObj.keyCode = 159
    } else {
      callbackObj.keyCode = 651
    }
    if (this.isAndroid()) {
      jsObj.action_24gameLogin(JSON.stringify(callbackObj))
    } else {
      window.webkit.messageHandlers.action_24gameLogin.postMessage(callbackObj)
    }
  },
}

const miniLogin = {
  // fn为登录后的回调
  callMiniLogin: function (url) {
    let userId = ''
    if (localStorage.getItem('webUserId')) {
      userId = localStorage.getItem('webUserId')
    }
    localStorage.setItem('buySellCars', 'true')
    let href = url || window.location.href
    console.log('去小程序登录', href)

    let codeKey = ''
    const enableMinCode = localStorage.getItem('enableMinCode')
    if (localStorage.play24 == 1) {
      if (window.env == 'sit' || window.env == 'dev') {
        codeKey = 124
      } else if (window.env == 'uat') {
        codeKey = 159
      } else {
        codeKey = 651
      }
    } else if (enableMinCode) {
      codeKey = localStorage.getItem('MkeyCode') || ''
    }
    //推客领券
    let tkId = ''
    if (localStorage.getItem('webTkId')) {
      tkId = localStorage.getItem('webTkId')
    }
    wx.miniProgram.navigateTo({
      url: `/pages/tologin/tologin?url=${encodeURIComponent(href)}&userId=${userId}&codeKey=${codeKey}&tkId=${tkId}`,
    })
    localStorage.removeItem('enableMinCode')
  },
}

const mLogin = {
  callMLogin: function () {
    if (window.env == 'sit' || window.env == 'dev') {
      if (localStorage.play24 == 1) {
        localStorage.setItem('MkeyCode', 124)
      }
      location.replace(`https://m.rv2go.cn/rent/v2/login?backurl=${encodeURIComponent(location.href)}`)
    } else if (window.env == 'uat') {
      if (localStorage.play24 == 1) {
        localStorage.setItem('MkeyCode', 159)
      }
      location.replace(`https://m-uat.rv2go.cn/rent/v2/login?backurl=${encodeURIComponent(location.href)}`)
    } else {
      if (localStorage.play24 == 1) {
        localStorage.setItem('MkeyCode', 651)
      }
      location.replace(`https://m.rv2go.com/rent/v2/login?backurl=${encodeURIComponent(location.href)}`)
    }
  },
}

/**
 * @description: app 小程序登录后 通过sign登录 如果是m站环境已登录直接执行回调
 * @param {*} fn 登录后回调
 * @return {*}
 */
const signLogin = async (fn) => {
  const client = await getEnv()
  let sign
  if (client == 'mini') {
    sign = getQueryString(location.href, 'sign')
  } else if (client == 'app') {
    sign = sessionStorage.sign || ''
  }
  if (sign && sign != 'undefined') {
    const { code } = await loginBySign(sign)
    if (+code === 0 && fn && typeof fn === 'function') {
      fn()
    }
  } else {
    if (fn && typeof fn === 'function') {
      fn()
    }
  }
}

const signLoginNew = async (fn) => {
  const client = await getEnv()
  let sign
  if (client == 'app') {
    sign = sessionStorage.sign || ''
  }
  if (sign && sign != 'undefined') {
    const { code } = await loginBySign(sign)
    if (+code === 0 && fn && typeof fn === 'function') {
      fn()
    }
  } else {
    if (fn && typeof fn === 'function') {
      fn()
    }
  }
}

const staffLogin = () => {
  if (window.env == 'sit' || window.env == 'dev') {
    location.replace(`https://m.rv2go.cn/rent/v2/staff-login?backurl=${encodeURIComponent(location.href)}&logintype=1`)
  } else if (window.env == 'uat') {
    location.replace(
      `https://m-uat.rv2go.cn/rent/v2/staff-login?backurl=${encodeURIComponent(location.href)}&logintype=1`
    )
  } else {
    location.replace(`https://m.rv2go.com/rent/v2/staff-login?backurl=${encodeURIComponent(location.href)}&logintype=1`)
  }
}

export { appLogin, miniLogin, mLogin, signLogin, signLoginNew, staffLogin }



// WEBPACK FOOTER //
// ./src/assets/js/aboutLogin.js